






























































import { Component, Prop, Vue } from "vue-property-decorator";
import { splitString } from "@/services/strings";

import Progress from "./progress.vue";

import { size, type } from "@/config/files.config.json";
import { AxiosRequestConfig } from "axios";
import { pics } from "@/config/host.config";

interface IImageParams {
  poster_name: string | null;
  lang: string | undefined;
  path: string;
  name: boolean;
  resizewidth: number | undefined;
  resizeheight: number | undefined;
}

interface IProgress {
  fileName: string;
  variant: string;
  progress: number;
  type: boolean;
  size: boolean;
}

interface IWH {
  width: number;
  height: number;
}

@Component({
  components: {
    "progress-component": Progress,
  },
})
export default class UploadingImagesToServer extends Vue {
  @Prop({ type: String, default: null }) upload!: string;
  @Prop({ type: String, default: null }) folder!: string;
  @Prop({ type: String, default: null }) image!: string;
  @Prop({ type: String, default: pics.newupload }) host!: string;
  @Prop({ type: String, default: null }) locale!: string;
  @Prop({ type: Object, default: null }) widthHeight!: IWH;

  files: Array<File> = [];
  progress: Array<IProgress> = [];
  posters_name: Array<string> = [];
  saweName = true;
  showUpload = true;

  // progress
  poster_prodress_variant = "primary";
  poster_value_progress = 0;
  posters_progress = false;

  size = size.image;
  type = type.image;

  $refs!: {
    file: HTMLInputElement;
  };

  clear(): void {
    // this.progress = [];
    this.files = [];
    this.posters_name = [];
  }

  getFileFormat(string: string | undefined): boolean {
    const space = "/";
    if (string != undefined) {
      const split_arr = splitString(string, space);
      return this.type.includes(split_arr[split_arr.length - 1]);
    } else {
      return false;
    }
  }
  uploadFiles(): void {
    const files: FileList | null = this.$refs.file.files;
    if (!files || !files?.length) return;
    this.showUpload = true;
    for (let i = 0; i < files.length; i++) {
      this.uploadFormData(files[i], i);
    }
  }

  uploadFormData(file: File | null, i: number): void {
    if (!file) return;
    const fileName = file.name;
    const type = this.getFileFormat(file.type);
    const size = file.size <= this.size ? true : false;

    const progress: IProgress = {
      fileName: fileName,
      variant: type && size ? "primary" : "danger",
      progress: 0,
      type: type,
      size: size,
    };
    this.progress.push(progress);
    this.files.push(file);
    let formData = new FormData();
    formData.append("poster", file);

    const params: IImageParams = {
      path: this.folder,
      name: this.saweName,
      resizewidth: this.widthHeight ? this.widthHeight.width : undefined,
      resizeheight: this.widthHeight ? this.widthHeight.height : undefined,
      poster_name: fileName,
      lang: this.locale ? this.locale : undefined,
    };

    const config = {
      headers: {
        "Content-Type": "multipart/form-data;charset=utf-8",
      },
      onDownloadProgress: (e: ProgressEvent) => {
        this.progress[i].progress = Math.round((e.loaded * 100) / e.total);
      },
      params: params,
    };
    this.sendNewFile(formData, config, i);
  }

  async sendNewFile(
    formData: FormData,
    config: AxiosRequestConfig,
    i: number
  ): Promise<void> {
    try {
      const image = await this.$axios.post(this.host, formData, config);
      if (image.status === 200) this.$emit("updatePoster", image.data);
    } catch (error) {
      this.progress[i].variant = "danger";
    }
    if (i == this.files.length - 1) this.$emit("finished");
  }
}
